import Image from 'next/image';
import React from 'react';
import { bro } from '../../../public/assets/images';

const ComingSoon = () => {
  return (
    <section className="container flex items-center justify-center flex-col h-full w-full">
      <div>
        <Image src={bro} alt="Yoo!!, StakeCut is coming soon, get ready" />
      </div>
      <h2 className="text-lg mt-5">Coming Soon...</h2>
    </section>
  );
};

export default ComingSoon;
